import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.jsx'
import './index.css'
import './styles/theme.css'
import { registerServiceWorker } from './lib/serviceWorker.js'
import { handleError } from './utils/errorHandling.js'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minute before data is considered stale
      gcTime: 5 * 60 * 1000, // 5 minutes before unused data is garbage collected
      retry: 2,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      onError: (error) => {
        handleError(error, 'Application error', { silent: true })
      },
    },
    mutations: {
      retry: 1,
      onError: (error) => {
        handleError(error, 'Application error', { silent: true })
      },
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
)

// Register service worker for PWA support
if ('serviceWorker' in navigator) {
  registerServiceWorker()
}
